import React, {useEffect, useState} from 'react';
import {View, StyleProp, ViewStyle, StyleSheet, Pressable} from 'react-native';
import {IconName} from '../../../assets/Icones';
import Metrics from '../../../Theme/Metrics';
import Icon from '../../Icon/Icon';
import Typography from '../../Typography/Typography';

export type CardHomeProfileProps = {
  icon: IconName;
  title: string;
  onPress?(): void;
  count?: number;
  style?: StyleProp<ViewStyle>;
  initialValue?: boolean;
};

export default function CardHomeProfile(props: CardHomeProfileProps) {
  const {icon, title, onPress, count, style = {}, initialValue} = props;

  const [isActive, setIsActive] = useState(initialValue);

  useEffect(() => {
    if (initialValue !== isActive) {
      setIsActive(initialValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialValue]);

  return (
    <Pressable
      onPress={() => {
        onPress && onPress();
        setIsActive(!isActive);
      }}
      style={StyleSheet.flatten([
        {
          alignItems: 'center',
          backgroundColor: '#1B1C21',
          borderRadius: 4,
          paddingHorizontal: Metrics.horizontalScale(12),
          paddingTop: Metrics.verticalScale(20),
          paddingBottom: Metrics.verticalScale(15),
          borderWidth: 1,
          borderColor: 'transparent',
        },
        style,
      ])}>
      <View
        style={{
          flexDirection: 'row',
          justifyContent: 'center',
        }}>
        <View
          style={{
            position: 'relative',
          }}>
          {count !== undefined && (
            <View
              style={{
                width: Metrics.horizontalScale(20),
                height: Metrics.horizontalScale(20),
                backgroundColor: '#EA6C13',
                borderRadius: Metrics.horizontalScale(10),
                position: 'absolute',
                top: Metrics.horizontalScale(-10),
                right: Metrics.horizontalScale(-10),
                justifyContent: 'center',
                alignItems: 'center',
              }}>
              <Typography variant="button1">{count}</Typography>
            </View>
          )}
          <Icon name={icon} />
        </View>
      </View>
      <Typography
        variant="body2"
        numberOfLines={1}
        style={{
          marginTop: Metrics.verticalScale(8),
          textAlign: 'center',
        }}>
        {title}
      </Typography>
    </Pressable>
  );
}
